(()=>{
  const API='https://mexa-inventory.mexajewelryllc.workers.dev/';
  let request=0;

  const getBox=()=>{
    return document.querySelector('[data-mexa-inventory]');
  };

  const getVariantId=()=>{
    /*
      Primero usamos el input real del formulario.
      Dawn actualiza este input cuando cambia la variante.
    */
    const input=document.querySelector('product-info input[name="id"]');

    if(input?.value){
      return String(input.value);
    }

    /*
      Fallback por si algún producto/theme no tiene
      disponible el input anterior.
    */
    const el=document.querySelector(
      'variant-selects [data-selected-variant]'
    );

    if(el){
      try{
        const variant=JSON.parse(el.textContent);

        if(variant?.id){
          return String(variant.id);
        }
      }catch(error){}
    }

    return null;
  };

  const show=(box,green,message)=>{
    const dot=box.querySelector('.mexa-stock-dot');
    const text=box.querySelector('.mexa-inventory-text');

    if(!dot||!text)return;

    const color=green?'#3ed660':'#ee9441';

    dot.style.backgroundColor=color;
    dot.style.color=color;
    dot.style.boxShadow=
      `0 0 5px ${color}, 0 0 10px ${color}`;

    text.textContent=message;

    /*
      Solamente mostramos el banner
      cuando ya tenemos la información.
    */
    box.style.display='';
  };

  async function update(){
    const box=getBox();

    if(!box)return;

    /*
      Esperamos aquí a que Dawn haya terminado
      de actualizar el variant ID.
    */
    await new Promise(resolve=>setTimeout(resolve,100));

    const id=getVariantId();

    if(!id)return;

    const currentRequest=++request;

    try{
      const response=await fetch(
        API+'?variant_id='+encodeURIComponent(id),
        {
          cache:'no-store'
        }
      );

      const data=await response.json();

      /*
        Si mientras consultábamos el cliente
        volvió a cambiar de variante, ignoramos
        esta respuesta anterior.
      */
      if(currentRequest!==request)return;

      if(
        !response.ok ||
        !data.ok ||
        !data.inventory
      ){
        console.error(
          'MEXA Inventory API:',
          data
        );
        return;
      }

      const phx=Number(data.inventory.phx||0);
      const jal=Number(data.inventory.jal||0);
      const country=box.dataset.country;

      if(country==='US'){
        show(
          box,
          phx>0,
          phx>0
            ? box.dataset.usFast
            : box.dataset.usImport
        );
      }

      else if(country==='MX'){
        show(
          box,
          jal>0,
          jal>0
            ? box.dataset.mxAvailable
            : box.dataset.mxImport
        );
      }

    }catch(error){
      console.error(
        'MEXA Inventory Error:',
        error
      );
    }
  }

  function start(){
    const picker=document.querySelector('variant-selects');

    const controls=picker
      ? picker.querySelectorAll(
          'input[type="radio"], select'
        )
      : [];

    /*
      PRODUCTO SIN OPCIONES:
      consulta automáticamente al entrar.
    */
    if(!picker || controls.length===0){
      update();
    }

    /*
      PRODUCTO CON OPCIONES:
      esperamos a que el cliente cambie una opción.

      Escuchamos desde document porque Dawn
      puede reconstruir el variant picker.
    */
    document.addEventListener('change',event=>{
      const target=event.target;

      if(
        target.closest('variant-selects') ||
        target.closest('.product-form__input')
      ){
        update();
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  }else{
    start();
  }
})();